// Native Navigation Bridge — see docs "Native Navigation Bridge - Web App
// Integration Guide". The Android driver app is a WebView container around
// this web app; when running inside it, window.Android is injected and
// startNavigation launches the standalone Google Maps app in turn-by-turn
// mode. Outside that WebView (regular browser, local dev) window.Android
// doesn't exist, so callers must fall back to a normal web maps link.
//
// One-way bridge only (web -> native) — there is no callback for when the
// driver backs out of Maps, Maps isn't installed, or the destination was
// invalid. Treat startNativeNavigation as fire-and-forget; don't build UI
// that depends on knowing when navigation ends.

export function startNativeNavigation(lat, lng, address, isLatLng, label) {
  if (!isNativeAppAvailable()) return false;
  window.Android.startNavigation(lat, lng, address, isLatLng, label);
  return true;
}

export function stopNativeNavigation() {
  if (
    typeof window === 'undefined' ||
    !window.Android ||
    typeof window.Android.stopNavigation !== 'function'
  ) {
    return false;
  }
  window.Android.stopNavigation();
  return true;
}

function isNativeAppAvailable() {
  return (
    typeof window !== 'undefined' &&
    !!window.Android &&
    typeof window.Android.startNavigation === 'function'
  );
}
